import { useCallingContext } from "@/hooks/dialer/use-dialer-context";
import { DIALER_MODES } from "@/constants/dialer";

export const useCallingMode = () => useCallingContext().mode;

export const useIsCatchupsWalkthroughMode = () =>
  useCallingMode() === DIALER_MODES.CATCHUP_WALKTHROUGH;
